export default __webpack_public_path__ + "static/media/rocketclear.9a2ebf61.gif";